import { differenceInDays } from 'date-fns';
import React from 'react';

export const useCenteredItem = (openDate: Date, openedDate: Date, minDate: Date) => {
	return React.useMemo(() => {
		let centeredItem = 0;

		if (openDate) {
			centeredItem = differenceInDays(openedDate ? openedDate : openDate, minDate);
		}

		return centeredItem;
	}, [openDate, openedDate, minDate]);
};
